export default __webpack_public_path__ + "static/media/newicon.7c9b7e96.png";